var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"card"},[_c('div',{staticClass:"card-title"},[_vm._m(0),(!_vm.bulkDelete)?_c('p',{staticClass:"subtitle-1"},[_vm._v("Answer")]):_vm._e()]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question"},[_c('p',{staticClass:"subtitle-1"},[_vm._v("Question")])])
}]

export { render, staticRenderFns }